import { render, staticRenderFns } from "./teoriakoulutus-form.vue?vue&type=template&id=0222b048&scoped=true&"
import script from "./teoriakoulutus-form.vue?vue&type=script&lang=ts&"
export * from "./teoriakoulutus-form.vue?vue&type=script&lang=ts&"
import style0 from "./teoriakoulutus-form.vue?vue&type=style&index=0&id=0222b048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222b048",
  null
  
)

export default component.exports